import React, { useEffect, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Select from "../common/form/select";
import { setModoTela, getLista, setAguardando, resetarFiltro, setFiltro, getListaGraficoGeracaoSaldo, gerarRelatorio } from "./gestaoCreditoSolarActions";

import { getListaGrupoFaturamento } from "../cliente/clienteActions";
import { Loading } from "../common/loading/loading";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { setError } from "../common/toast/toast";
import TableInCell from "../common/table/tableInCell";
import NumberFormat from "react-number-format";
import Button from "../common/button/button";
import { ModalAlert } from "../common/dialog/modalAlert";
import { GraficoSaldoGeracao } from "../fatura/components/GraficoSaldoGeracao";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import Grid from "../common/layout/grid";
import { GraficoAproveitamentoUsina } from "./GraficoAproveitamentoUsina";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { validarTarifaMediaLiquida } from "../core/validarTarifaMediaLiquida";
import { calcularTarifaMediaLiquidaBruta } from "../core/calcularTarifaMediaLiquidaBruta";
import { ArrowOrEqualIcon } from "../common/arrowOrEqualIcon/ArrowOrEqualIcon";
import { SolCasaGestaoCreditoSolar } from "./SolCasaGestaoCreditoSolar";

const ALTURA_LINHA = 140;
const QUANTIDADE_PADRAO_LINHAS = 15;

function GestaoCreditoSolar(props) {
    const tableRef = useRef(null);

    const [state, setState] = useState({
        aguardando: false,
        qtdLinhasRenderizadas: QUANTIDADE_PADRAO_LINHAS,
        sugestaoRateio: {},
        exibirGraficoSaldoGeracao: false,
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    useEffect(() => {
        if (!props.usuarioLogado) return;
        carregarDados(); // ou os dispatchs

        return props.resetarFiltro;
    }, []);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        carregarDados(); // ou os dispatchs
    }, [props.usuarioLogado]);

    function resetarListaTabela() {
        setState(
            {
                ...state,
                qtdLinhasRenderizadas: QUANTIDADE_PADRAO_LINHAS,
                aguardando: false,
            },
            () => tableRef && tableRef.current && tableRef.current.scrollToTop()
        );
    }

    function carregarDados() {
        props.getListaGrupoFaturamento();
        if (props.usuarioLogado && props.usuarioLogado.administrador) {
            props.getLista();
        } else if (props.usuarioLogado && props.usuarioLogado.acesso_cliente) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: props.usuarioLogado.id_cliente,
            });
            props.getLista();
        }
    }

    if (props.pdf) {
        return <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} zoomParametro={1.5} />;
    }
    return (
        <div>
            <Content>
                <div>{props.modoTela === "lista" ? lista() : null}</div>
            </Content>
        </div>
    );

    function lista() {
        let totalValorImportado = 0;
        let totalenergia = 0;
        let totalSobraDistribuirCompensacoes = 0;
        let totalEnergiaExcedente = 0;
        let totalProducaoSolar = 0;
        let totalSaldo = 0;

        //totais de registros por cores
        let quantidadeUnidadesFiltradas = 0;

        const faturas = filtrarFaturasTabela().map((item, i, lista) => {
            quantidadeUnidadesFiltradas++;
            totalEnergiaExcedente += parseFloat(item.energia_excedente || 0);
            totalProducaoSolar += parseFloat(item.quantidade_geracao || 0);
            totalSaldo += parseFloat(item.saldo_geracao || 0);
            totalSobraDistribuirCompensacoes += item.energia_excedente - item.energia < 0 ? 0 : item.energia_excedente - item.energia;
            totalenergia += parseFloat(item.energia || 0);
            totalValorImportado += parseFloat(item.total > 0 ? item.total : 0);

            if (i >= state.qtdLinhasRenderizadas) return null;

            const { tarifaMediaLiquida, tarifaMediaBruta } = calcularTarifaMediaLiquidaBruta(item);

            const corTextoLinha = "#FFF";
            const backgroundMiniTabela = "#7d94fb";
            const backgroundColorTd = "#6a7fd5";
            const backgroundColorTr = "#3c55ab";

            //se for rge mostra os os 3 valores (ponta,fora ponta, reservado)
            const tarifaRGE =
                parseFloat(item.tarifa_energia_ponta) >= 0 || parseFloat(item.tarifa_energia_fora_ponta) >= 0 || parseFloat(item.tarifa_energia_horario_reservado) >= 0;

            const tarifaSelecionada = tarifaRGE
                ? [
                      {
                          cabecalho: <div title="Tarifa Energia Ponta">T.P</div>,
                          valor: parseFloat(item.tarifa_energia_ponta) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_ponta, 4) : " - ",
                      },
                      {
                          cabecalho: <div title="Tarifa Energia Fora Ponta">T.FP</div>,
                          valor: parseFloat(item.tarifa_energia_fora_ponta) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_fora_ponta, 4) : " - ",
                      },
                      {
                          cabecalho: <div title="Tarifa Energia Horário Reservado">T.R</div>,
                          valor: parseFloat(item.tarifa_energia_horario_reservado) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_horario_reservado, 4) : " - ",
                      },
                  ]
                : [
                      {
                          cabecalho: <div title="Tarifa">T</div>,
                          valor: adicionarPontosMilhar(item.tarifa_economia || 0),
                      },
                  ];
            const tarifa = (
                <TableInCell
                    backgroundColor={backgroundMiniTabela}
                    borderColor={corTextoLinha}
                    height={ALTURA_LINHA}
                    lista={[
                        ...tarifaSelecionada,
                        {
                            cabecalho: <div title="Tarifa Média Líquida">T.ML</div>,
                            valor: parseFloat(tarifaMediaLiquida) >= 0 ? adicionarPontosMilhar(tarifaMediaLiquida, 4) : " - ",
                        },
                        {
                            cabecalho: <div title="Tarifa Média Bruta">T.MB</div>,
                            valor: parseFloat(tarifaMediaBruta) >= 0 ? adicionarPontosMilhar(tarifaMediaBruta, 4) : " - ",
                        },
                    ]}
                />
            );

            const corSaldo = (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? "#FFF" : "#890000";
            const corTabelaSaldo = (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? backgroundMiniTabela : "#ff6381";

            const alertaMedidor = (item.alertas.find((a) => a.tipo === "Número do Medidor") || {}).mensagem;

            const energiaCompensadaEfetivo = 0; //descobrir de onde vem esse valor
            const percentualEnergiaCompensadaEfetiva = item.energia_excedente - item.energia < 0 ? 0 : (energiaCompensadaEfetivo / (item.energia_excedente - item.energia)) * 100;

            const corPercentualEnergiaCompensadaEfetiva = percentualEnergiaCompensadaEfetiva <= 50 ? "#5fedff" : percentualEnergiaCompensadaEfetiva > 95 ? "#0c672e" : "#95720e";
            const backgroundPercentualEnergiaCompensadaEfetiva =
                percentualEnergiaCompensadaEfetiva <= 50 ? "#21255a" : percentualEnergiaCompensadaEfetiva > 95 ? "#4dffb3" : "#f7f898";

            const economiaTotal =
                (parseFloat(item[item.unidade_geradora ? "consumo_instantaneo" : "consumo_instantaneo_fonte_geradora"]) || 0) +
                (parseFloat(item[item.unidade_geradora ? "quantidade_economia_geradora_remotas" : "quantidade_economia_geradora_remotas_fonte_geradora"]) || 0);
            const economiaGeradora = (parseFloat(item.quantidade_economia) || 0) + parseFloat(item.consumo_instantaneo || 0);
            const economiaRemota = parseFloat(item.quantidade_economia) || 0;
            let percentualEconomiaUnidade = "(%)";

            if (item.unidade_geradora) {
                percentualEconomiaUnidade = economiaGeradora ? "(" + adicionarPontosMilhar((economiaGeradora * 100) / economiaTotal) + "%)" : percentualEconomiaUnidade;
            } else {
                percentualEconomiaUnidade = economiaRemota ? "(" + adicionarPontosMilhar((economiaRemota * 100) / economiaTotal) + "%)" : percentualEconomiaUnidade;
            }
            return (
                <NewTr key={item.id} backgroundColorTr={backgroundColorTr} backgroundColorTd={backgroundColorTd} noButtons style={{ color: corTextoLinha }}>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>

                        <SolCasaGestaoCreditoSolar fatura={item}/>
                        {item.unidade_geradora || item.unidade_remota ? (
                            <div>
                                <Button
                                    title="Visualizar gráfico de saldo de geração (kWh)"
                                    text={
                                        <div style={{ fontSize: "0.8rem" }}>
                                            <i className="fas fa-chart-bar mr-2"></i>Saldos
                                        </div>
                                    }
                                    hoverStyle={{ filter: "brightness(1.1)" }}
                                    style={{
                                        background: "linear-gradient(#24437d, #102547)",
                                        borderRadius: "0.3rem",
                                        color: "#fff",
                                        margin: "0 0 2px 0",
                                        padding: 3,
                                    }}
                                    disabled={!item.unidade_geradora && !item.unidade_remota}
                                    event={() => {
                                        props.getListaGraficoGeracaoSaldo({
                                            id_cliente: item.id_cliente,
                                            id_unidade_consumidora: item.id_unidade_consumidora,
                                        });
                                        setState({
                                            ...state,
                                            exibirGraficoSaldoGeracao: true,
                                            itemSelecionado: {
                                                id_cliente: item.id_cliente,
                                                id_unidade_consumidora: item.id_unidade_consumidora,
                                            },
                                        });
                                    }}
                                />
                            </div>
                        ) : null}
                        {[1, 4].includes(item.id_grupo_faturamento) ? (
                            <TableInCell
                                backgroundColor={corTabelaSaldo}
                                borderColor={corTextoLinha}
                                lista={[
                                    {
                                        cabecalho: <div style={{ color: corSaldo }}> P </div>,
                                        valor: (
                                            <div className="d-flex justify-content-center  align-items-center" style={{ color: corSaldo }}>
                                                {" "}
                                                {item.unidade_geradora || item.unidade_remota ? " " + Math.round(item.saldo_geracao_ponta || 0) : " - "}{" "}
                                            </div>
                                        ),
                                    },
                                    {
                                        cabecalho: <div style={{ color: corSaldo }}> FP </div>,
                                        valor: (
                                            <div className="d-flex justify-content-center  align-items-center" style={{ color: corSaldo }}>
                                                {" "}
                                                {item.unidade_geradora || item.unidade_remota ? " " + Math.round(item.saldo_geracao_fora_ponta || 0) : " - "}{" "}
                                            </div>
                                        ),
                                    },
                                    {
                                        cabecalho: <div style={{ color: corSaldo }}> Total </div>,
                                        valor:
                                            item.unidade_geradora || item.unidade_remota ? (
                                                <div className="d-flex justify-content-center align-items-center" style={{ color: corSaldo }}>
                                                    <span>{Math.round(item.saldo_geracao || 0)}</span>
                                                    <ArrowOrEqualIcon
                                                        iconName={
                                                            item.saldo_geracao > item.saldo_geracao_mes_anterior
                                                                ? "arrowUpGreen"
                                                                : item.saldo_geracao < item.saldo_geracao_mes_anterior
                                                                  ? "arrowDownRed"
                                                                  : item.saldo_geracao == item.saldo_geracao_mes_anterior
                                                                    ? "equalBlue"
                                                                    : null
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div className="d-flex justify-content-center" style={{ color: corSaldo }}>
                                                    {" - "}
                                                </div>
                                            ),
                                    },
                                ]}
                            />
                        ) : (
                            <div style={{ color: corSaldo, backgroundColor: corTabelaSaldo, border: `1px solid ${corTextoLinha}` }}>
                                {item.unidade_geradora || item.unidade_remota ? (
                                    <div className="d-flex justify-content-center  align-items-center">
                                        <span>{Math.round(item.saldo_geracao || 0)}</span>
                                        <ArrowOrEqualIcon
                                            iconName={
                                                item.saldo_geracao > item.saldo_geracao_mes_anterior
                                                    ? "arrowUpGreen"
                                                    : item.saldo_geracao < item.saldo_geracao_mes_anterior
                                                      ? "arrowDownRed"
                                                      : item.saldo_geracao == item.saldo_geracao_mes_anterior
                                                        ? "equalBlue"
                                                        : null
                                            }
                                        />
                                    </div>
                                ) : (
                                    " - "
                                )}
                            </div>
                        )}
                    </Td>
                    <Td fontSize="0.8rem" minWidth={245}>
                        <div style={{ display: "flex", flexDirection: "column", height: ALTURA_LINHA }}>
                            <div className="p-1 mb-1" style={{ flexGrow: 1, border: `1px solid ${corTextoLinha}` }}>
                                <b className="pr-1">Cliente:</b> {item.nome_cliente}
                            </div>
                            <div className="p-1" style={{ flexGrow: 1, border: `1px solid ${corTextoLinha}` }}>
                                <b className="pr-1">UC:</b>
                                {item.nome_unidade_consumidora}
                                {" - "}
                                {item.nome_concessionaria}
                            </div>
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" minWidth={250}>
                        <div style={{ display: "flex", flexDirection: "column", height: ALTURA_LINHA }}>
                            <div className="p-1 mb-1" style={{ flexGrow: 1, border: `1px solid ${corTextoLinha}` }}>
                                <b className="pr-1">Competência:</b>
                                {`${String(item.competencia).substring(4, 6)}/${String(item.competencia).substring(0, 4)}`}
                            </div>
                            <div className="p-1" style={{ flexGrow: 1, border: `1px solid ${corTextoLinha}` }}>
                                <b className="pr-1">Período:</b>
                                {item.data_leitura_anterior && item.data_leitura_atual ? `De ${item.data_leitura_anterior} até ${item.data_leitura_atual}` : " - "}
                            </div>
                        </div>
                    </Td>

                    <Td fontSize="0.8rem" alignCenter>
                        <div className="d-flex">
                            <GraficoAproveitamentoUsina id={item.id + "-mes"} periodo={"mes"} item={item} />
                            <GraficoAproveitamentoUsina id={item.id + "-ano"} periodo={"ano"} item={item} />
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>
                        {tarifa}
                    </Td>

                    <Td fontSize="0.8rem" alignCenter minWidth={60}>
                        <>
                            <div
                                title={alertaMedidor}
                                style={{
                                    lineHeight: "0.8rem",
                                    marginBottom: 2,
                                    border: `1px solid ${alertaMedidor ? "#ff004f" : corTextoLinha}`,
                                    textAlign: "center",
                                    backgroundColor: alertaMedidor ? "#ff004f" : backgroundMiniTabela,
                                    color: "#fff",
                                }}
                            >
                                <div style={{ fontWeight: "bolder", fontSize: "0.65rem" }}>Nº Medidor</div>
                                <div>{item.numero_medidor || " - "}</div>
                            </div>
                            {[1, 4].includes(item.id_grupo_faturamento) ? (
                                <TableInCell
                                    backgroundColor={backgroundMiniTabela}
                                    borderColor={corTextoLinha}
                                    height={110}
                                    lista={[
                                        {
                                            cabecalho: <div style={{ fontWeight: "bolder" }}> Hor. </div>,
                                            valores: [<div style={{ fontWeight: "bolder" }}>Consumo</div>, <div style={{ fontWeight: "bolder" }}>Injetada</div>],
                                        },
                                        {
                                            cabecalho: <div> P </div>,
                                            valores: [
                                                <div>{item.constante_medidor_consumida_ponta ? adicionarPontosMilhar(item.constante_medidor_consumida_ponta, 4) : " - "}</div>,
                                                <div>{item.constante_medidor_injetada_ponta ? adicionarPontosMilhar(item.constante_medidor_injetada_ponta, 4) : " - "}</div>,
                                            ],
                                        },
                                        {
                                            cabecalho: <div> FP </div>,
                                            valores: [
                                                <div>
                                                    {item.constante_medidor_consumida_fora_ponta ? adicionarPontosMilhar(item.constante_medidor_consumida_fora_ponta, 4) : " - "}
                                                </div>,
                                                <div>
                                                    {item.constante_medidor_injetada_fora_ponta ? adicionarPontosMilhar(item.constante_medidor_injetada_fora_ponta, 4) : " - "}
                                                </div>,
                                            ],
                                        },
                                        {
                                            cabecalho: <div> Res. </div>,
                                            valores: [
                                                <div>
                                                    {item.constante_medidor_consumida_reservado ? adicionarPontosMilhar(item.constante_medidor_consumida_reservado, 4) : " - "}
                                                </div>,
                                                <div>
                                                    {item.constante_medidor_injetada_reservado ? adicionarPontosMilhar(item.constante_medidor_injetada_reservado, 4) : " - "}
                                                </div>,
                                            ],
                                        },
                                    ]}
                                />
                            ) : (
                                <TableInCell
                                    backgroundColor={backgroundMiniTabela}
                                    borderColor={corTextoLinha}
                                    height={110}
                                    cabecalhoCentralizado={true}
                                    width={"100%"}
                                    lista={[
                                        {
                                            cabecalho: <div style={{ fontWeight: "bolder" }}>Consumo</div>,
                                            valor: (
                                                <div style={{ fontWeight: "bolder" }}>
                                                    <div>Injetada</div>
                                                </div>
                                            ),
                                        },
                                        {
                                            cabecalho: (
                                                <div style={{ textAlign: "center" }}>
                                                    {item.constante_medidor_consumida ? adicionarPontosMilhar(item.constante_medidor_consumida, 4) : " - "}
                                                </div>
                                            ),
                                            valor: <div>{item.constante_medidor_injetada ? adicionarPontosMilhar(item.constante_medidor_injetada, 4) : " - "}</div>,
                                            width: 85,
                                        },
                                    ]}
                                />
                            )}
                        </>
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>
                        <div
                            style={{
                                padding: 2,
                                display: "flex",
                                flexWrap: "nowrap",
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "1.4rem",
                            }}
                        >
                            {adicionarPontosMilhar(item.valor_fatura || 0)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter>
                        <TableInCell
                            backgroundColor={backgroundMiniTabela}
                            borderColor={corTextoLinha}
                            height={ALTURA_LINHA}
                            lista={
                                item.unidade_geradora
                                    ? [
                                          {
                                              cabecalho: (
                                                  <div>
                                                      <div style={{ height: 12, marginTop: 12 }}>Geradora</div>
                                                      <div style={{ height: 12 }}>(kWh/R$)</div>
                                                  </div>
                                              ),
                                              rowSpanCabecalho: 3,
                                              valores: [
                                                  "Crédito Fatura",
                                                  adicionarPontosMilhar(parseFloat(item.quantidade_economia || 0)) + " kWh",
                                                  "R$ " + adicionarPontosMilhar(item.valor_economia || 0),
                                              ],
                                              //   widthValores: 100,
                                              maxWidthValores: 200,
                                          },
                                          {
                                              valores: [
                                                  "Crédito Instantâneo",
                                                  adicionarPontosMilhar(parseFloat(item.consumo_instantaneo || 0)) + " kWh",
                                                  "R$ " + adicionarPontosMilhar(item.valor_consumo_instantaneo || 0),
                                              ],
                                              //   widthValores: 100,
                                              maxWidthValores: 200,
                                          },
                                          {
                                              valores: [
                                                  "Crédito Total Geradora",
                                                  <div className="d-flex flex-wrap align-items-center" style={{ height: "100%", minHeight: 34 }}>
                                                      <div style={{ width: "100%", textAlign: "center" }}>
                                                          {adicionarPontosMilhar(parseFloat(item.quantidade_economia || 0) + parseFloat(item.consumo_instantaneo || 0)) + " kWh"}
                                                      </div>
                                                      {/* Calcula o percentual de economia da unidade, em relação a economia total da "familia" de ucs */}
                                                      <div style={{ width: "100%", textAlign: "center" }}>{percentualEconomiaUnidade}</div>
                                                  </div>,
                                                  "R$ " + adicionarPontosMilhar(parseFloat(item.valor_economia || 0) + parseFloat(item.valor_consumo_instantaneo || 0)),
                                              ],
                                              //   widthValores: 100,
                                              maxWidthValores: 200,
                                          },
                                          {
                                              cabecalho: (
                                                  <div>
                                                      {<div style={{ height: 12, marginTop: 12 }}></div>}
                                                      <div style={{ height: 12, paddingRight: 10 }}>Remotas</div>
                                                      <div style={{ height: 12 }}>(kWh/R$)</div>
                                                  </div>
                                              ),
                                              valores: [
                                                  "Crédito Total Remotas",
                                                  adicionarPontosMilhar(parseFloat(item.quantidade_economia_remotas || 0)) + " kWh",
                                                  "R$ " + adicionarPontosMilhar(item.valor_economia_remotas || 0),
                                              ],
                                              //   widthValores: 100,
                                              maxWidthValores: 200,
                                          },
                                          {
                                              cabecalho: (
                                                  <div>
                                                      {<div style={{ height: 12, marginTop: 12 }}>Geradora +</div>}
                                                      <div style={{ height: 12, paddingRight: 10 }}>Remotas</div>
                                                      <div style={{ height: 12 }}>(kWh/R$)</div>
                                                  </div>
                                              ),
                                              valores: [
                                                  "Credito Total",
                                                  adicionarPontosMilhar(parseFloat(item.quantidade_economia_geradora_remotas || 0) + parseFloat(item.consumo_instantaneo || 0)) +
                                                      " kWh",
                                                  "R$ " + adicionarPontosMilhar(item.valor_economia_geradora_remotas || 0),
                                              ],
                                              //   widthValores: 100,
                                              maxWidthValores: 200,
                                          },
                                      ]
                                    : [
                                          {
                                              cabecalho: (
                                                  <div>
                                                      <div style={{ height: 12, paddingRight: 10 }}>Remotas</div>
                                                      <div style={{ height: 12 }}>(kWh/R$)</div>
                                                  </div>
                                              ),
                                              valores: [
                                                  <div className="d-flex flex-wrap align-items-center" style={{ minHeight: 34, marginTop: 10 }}>
                                                      <div style={{ width: "100%", textAlign: "center" }}>{adicionarPontosMilhar(item.quantidade_economia || 0) + " kWh"}</div>
                                                      {/* Calcula o percentual de economia da unidade, em relação a economia total da "familia" de ucs */}
                                                      <div style={{ width: "100%", textAlign: "center" }}>{percentualEconomiaUnidade}</div>
                                                  </div>,
                                                  "R$ " + adicionarPontosMilhar(item.valor_economia || 0),
                                              ],
                                              widthValores: 135,
                                              maxWidthValores: 200,
                                          },
                                      ]
                            }
                        />
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>
                        {item.unidade_geradora ? (
                            <TableInCell
                                backgroundColor={backgroundMiniTabela}
                                borderColor={corTextoLinha}
                                height={ALTURA_LINHA}
                                lista={[
                                    {
                                        cabecalho: (
                                            <div>
                                                <div style={{ height: 12, marginTop: 12 }}>Produção</div>
                                                <div style={{ height: 12 }}>(kWh)</div>
                                            </div>
                                        ),
                                        valor: adicionarPontosMilhar(item.quantidade_geracao || 0),
                                    },
                                    {
                                        cabecalho: (
                                            <div>
                                                <div style={{ height: 12, marginTop: 12 }}>Injetado/</div>
                                                <div style={{ height: 12 }}>Excedente</div>
                                                <div style={{ height: 12 }}>(kWh)</div>
                                            </div>
                                        ),
                                        valor: adicionarPontosMilhar(item.energia_excedente || 0),
                                    },
                                ]}
                            />
                        ) : (
                            " - "
                        )}
                    </Td>

                    <Td fontSize={!validarTarifaMediaLiquida(tarifaMediaLiquida) ? "0.9rem" : "0.8rem"} minWidth={50} alignCenter>
                        <TableInCell
                            backgroundColor={backgroundMiniTabela}
                            borderColor={corTextoLinha}
                            height={ALTURA_LINHA}
                            lista={[
                                {
                                    cabecalho: (
                                        <div>
                                            <div style={{ height: 12, marginTop: 12 }}>Fatura</div>
                                            <div style={{ height: 12 }}>(kWh)</div>
                                        </div>
                                    ),
                                    valor: (
                                        <div>
                                            <div style={{ height: 12, marginTop: 12 }} title={`Energia Consumida pela UC: ${adicionarPontosMilhar(item.energia || 0)}`}>
                                                {adicionarPontosMilhar(item.energia || 0)}
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    cabecalho: (
                                        <div title={`(Geração: ${parseFloat(item.quantidade_geracao || 0)}) - (Excedente: ${parseFloat(item.energia_excedente || 0)})`}>
                                            <div style={{ height: 12, marginTop: 12 }}>Instantâneo</div>
                                            <div style={{ height: 12 }}>(kWh)</div>
                                        </div>
                                    ),
                                    valor: (
                                        <div title={`(Geração: ${parseFloat(item.quantidade_geracao || 0)}) - (Excedente: ${parseFloat(item.energia_excedente || 0)})`}>
                                            {adicionarPontosMilhar(item.consumo_instantaneo)}
                                        </div>
                                    ),
                                },
                                {
                                    cabecalho: (
                                        <div
                                            title={`(Consumo Fatura: ${adicionarPontosMilhar(item.energia || 0)} + Consumo Instantâneo: ${adicionarPontosMilhar(
                                                item.consumo_instantaneo
                                            )})/ (Consumo Geradoras e Remotas: ${adicionarPontosMilhar(item.energia_consumida_geradora_remotas || 0)})`}
                                        >
                                            <div style={{ height: 12, marginTop: 12 }}>Total</div>
                                            <div style={{ height: 12 }}>(kWh)</div>
                                        </div>
                                    ),
                                    valor: (
                                        <div
                                            title={`(Consumo Fatura: ${adicionarPontosMilhar(item.energia || 0)} + Consumo Instantâneo: ${adicionarPontosMilhar(
                                                item.consumo_instantaneo
                                            )})/ (Consumo Geradoras e Remotas: ${adicionarPontosMilhar(item.energia_consumida_geradora_remotas || 0)})`}
                                        >
                                            <div style={{ height: 12, marginTop: 12 }}>{adicionarPontosMilhar(item.energia_total)}</div>
                                            <div style={{ height: 12 }}>
                                                {item.energia_consumida_geradora_remotas > 0
                                                    ? "(" + adicionarPontosMilhar((item.energia_total / item.energia_consumida_geradora_remotas) * 100) + "%)"
                                                    : ""}
                                            </div>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </Td>

                    <Td fontSize="0.8rem" minWidth={50} maxWidth={50} alignCenter>
                        {adicionarPontosMilhar(item.energia_excedente - item.energia < 0 ? 0 : item.energia_excedente - item.energia)}
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} maxWidth={50} alignCenter>
                        {/* {energiaCompensadaEfetivo} */}?
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} maxWidth={50} alignCenter>
                        <div
                            style={{
                                display: "flex",
                                height: ALTURA_LINHA,
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: "bolder",
                                color: corPercentualEnergiaCompensadaEfetiva,
                                backgroundColor: backgroundPercentualEnergiaCompensadaEfetiva,
                            }}
                        >
                            {adicionarPontosMilhar(percentualEnergiaCompensadaEfetiva) + " %"}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} maxWidth={50} alignCenter>
                        {adicionarPontosMilhar(item.percentual_geracao) + " %"}
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>
                        <NumberFormat
                            className="form-control"
                            placeholder="simular"
                            decimalSeparator={","}
                            decimalScale={2}
                            fixedDecimalScale={2}
                            allowNegative={true}
                            onChange={(e) => {
                                const valorFormatado = parseFloat(e.target.value.replace(",", ".")) || 0;
                                setState({
                                    ...state,
                                    sugestaoRateio: {
                                        ...state.sugestaoRateio,
                                        [item.id]: valorFormatado,
                                    },
                                });
                            }}
                        />
                    </Td>
                    <Td fontSize="0.8rem" minWidth={50} alignCenter>
                        {(item.energia_excedente - item.energia < 0 ? 0 : item.energia_excedente - item.energia) * state.sugestaoRateio[item.id] || 0}
                    </Td>
                </NewTr>
            );
        });

        const listaFiltroUc = props.listaUnidadeConsumidora.filter((uc) => {
            const filtroCliente = (!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || uc.id_cliente == props.filtro.id_cliente;

            const filtroGrupoFaturamento = !props.filtro.id_grupo_faturamento || uc.id_grupo_faturamento == props.filtro.id_grupo_faturamento;
            //exibe apenas UCs condizentes com o filtro de geração solar
            const filtroGeracaoSolar = props.filtro.exibir_remotas ? uc.geracao || uc.remota : uc.geracao && !uc.id_unidade_geradora;
            return filtroCliente && filtroGrupoFaturamento && filtroGeracaoSolar;
        });

        const descricaoFiltroUc = props.filtro.exibir_remotas ? "Unidades Geradoras e Remotas" : "Unidades Geradoras";
        //------------------------------------------------
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                {props.aguardando || state.aguardando ? <Loading /> : null}
                {state.exibirGraficoSaldoGeracao && !props.pdf && !(props.aguardando || state.aguardando) ? (
                    <ModalAlert titulo="" handleClose={() => setState({ ...state, exibirGraficoSaldoGeracao: false, itemSelecionado: null })} maxWidth={"95%"}>
                        <GraficoSaldoGeracao registro={state.itemSelecionado} listaGraficoGeracaoSaldo={props.listaGraficoGeracaoSaldo} gerarRelatorio={props.gerarRelatorio} />
                    </ModalAlert>
                ) : null}
                <ContentCardHeader>
                    <Row style={{ paddingBlock: 15 }}>
                        {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                            <Select
                                readOnly={props.aguardando || state.aguardando}
                                name="id_cliente"
                                options={props.listaCliente}
                                label="Cliente"
                                cols="12 6 6 6"
                                placeholder="Selecione o Cliente"
                                value={props.filtro.id_cliente}
                                onChange={(value) => {
                                    if (!parseInt(props.filtro.ano) && !parseInt(props.filtro.mes) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                        return setError("Selecione alguma UC ou algum período para poder limpar o filtro");
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_cliente: value,
                                        unidades_consumidoras: [],
                                    });
                                    props.getLista();
                                    resetarListaTabela();
                                }}
                            />
                        ) : null}

                        <Select
                            readOnly={props.aguardando || state.aguardando}
                            name="ano"
                            options={Array.from({ length: 20 }, (v, i) => ({
                                id: new Date().getFullYear() - 5 + i,
                                valor: new Date().getFullYear() - 5 + i,
                            }))}
                            label="Ano"
                            isSearchable={false}
                            cols="12 6 2 2"
                            placeholder="Selecione o ano"
                            value={props.filtro.ano}
                            onChange={(value) => {
                                if (
                                    !parseInt(props.filtro.id_cliente) &&
                                    // !parseInt(props.filtro.mes) &&
                                    !parseInt(value) &&
                                    !props.filtro.unidades_consumidoras.length
                                ) {
                                    return setError("Selecione um cliente, uma UC ou um mês poder limpar o filtro");
                                }
                                props.setFiltro({
                                    ...props.filtro,
                                    ano: value,
                                });
                                props.getLista();
                                resetarListaTabela();
                            }}
                        />

                        <Select
                            readOnly={props.aguardando || state.aguardando}
                            name="mes"
                            options={props.listaMeses}
                            label="Mês"
                            isSearchable={false}
                            cols="12 6 2 2"
                            placeholder="Selecione o mês"
                            value={props.filtro.mes}
                            onChange={(value) => {
                                if (
                                    !parseInt(props.filtro.id_cliente) &&
                                    // !parseInt(props.filtro.ano) &&
                                    !parseInt(value) &&
                                    !props.filtro.unidades_consumidoras.length
                                ) {
                                    return setError("Selecione um cliente, uma UC ou um ano para poder limpar o filtro");
                                }
                                props.setFiltro({
                                    ...props.filtro,
                                    mes: value,
                                });
                                props.getLista();
                                resetarListaTabela();
                            }}
                        />
                        <Select
                            readOnly={props.aguardando || state.aguardando}
                            name="id_concessionaria"
                            options={props.listaConcessionaria}
                            label="Concessionária"
                            cols="12 6 2 2"
                            placeholder="Selecione a concessionaria"
                            isSearchable={false}
                            value={props.filtro.id_concessionaria}
                            onChange={(id_concessionaria) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_concessionaria,
                                });
                                props.getLista();
                                resetarListaTabela();
                            }}
                        />

                        {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                            <Select
                                readOnly={props.aguardando || state.aguardando}
                                options={listaFiltroUc}
                                label={
                                    <LabelSelectUcIconeGestor
                                        text={descricaoFiltroUc}
                                        isMulti={true}
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={listaFiltroUc}
                                        setExibirModal={(ucFiltro) =>
                                            setState({
                                                ...state,
                                                exibirModalGestorConcessionaria: true,
                                                itemSelecionado: ucFiltro,
                                            })
                                        }
                                    />
                                }
                                cols="12 12 6 6"
                                placeholder={`Selecione as ${descricaoFiltroUc}`}
                                isMulti={true}
                                value={props.filtro.unidades_consumidoras}
                                onChange={(ucsSelecionadas) => {
                                    if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(props.filtro.ano) && !ucsSelecionadas.length) {
                                        return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                                    }
                                    const ucFiltrada = ucsSelecionadas.length ? props.listaUnidadeConsumidora.find((uc) => uc.id == ucsSelecionadas[0].value) : null;
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_cliente: ucFiltrada ? ucFiltrada.id_cliente : props.filtro.id_cliente,
                                        unidades_consumidoras: [...ucsSelecionadas],
                                    });
                                    props.getLista();
                                    resetarListaTabela();
                                }}
                            />
                        ) : null}
                        <Grid cols="12 12 2 2">
                            <Button
                                title={props.filtro.exibir_remotas ? "Ocultar Remotas" : "Exibir Remotas"}
                                text={
                                    <div>
                                        {props.filtro.exibir_remotas ? <i className="fas fa-eye-slash mr-2"></i> : <i className="fas fa-home mr-2"></i>}
                                        {props.filtro.exibir_remotas ? "Ocultar Remotas" : "Exibir Remotas"}
                                    </div>
                                }
                                hoverStyle={{ filter: "brightness(1.1)" }}
                                style={{
                                    background: "linear-gradient(rgb(59 155 235), rgb(200 177 255))",
                                    border: "2px solid #7d88da",
                                    borderRadius: "0.3rem",
                                    color: "#fff",
                                    margin: window.innerWidth < 768 ? "0 0 2px 0" : "27px 0 2px 0",
                                    padding: 8,
                                }}
                                disabled={false}
                                event={() => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        exibir_remotas: !props.filtro.exibir_remotas,
                                    });
                                    resetarListaTabela();
                                }}
                            />
                        </Grid>

                        <Select
                            readOnly={props.aguardando || state.aguardando}
                            name="status_importacao"
                            options={props.listaStatusImportacao}
                            label="Status Importação"
                            cols="12 12 2 2"
                            placeholder="Selecione o tipo de faturamento"
                            isSearchable={false}
                            isClearable={false}
                            value={props.filtro.status_importacao}
                            onChange={(status_importacao) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    status_importacao,
                                });
                                resetarListaTabela();
                            }}
                        />
                        <Select
                            readOnly={props.aguardando || state.aguardando}
                            name="id_grupo_faturamento"
                            options={props.listaGrupoFaturamento}
                            label="Tipo de Faturamento"
                            cols="12 12 2 2"
                            placeholder="Selecione o tipo de faturamento"
                            isSearchable={false}
                            value={props.filtro.id_grupo_faturamento}
                            onChange={(id_grupo_faturamento) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_grupo_faturamento,
                                });
                                props.getLista();
                                resetarListaTabela();
                            }}
                        />

                        {props.usuarioLogado && props.usuarioLogado.acesso_cliente ? (
                            <Select
                                readOnly={props.aguardando || state.aguardando}
                                options={listaFiltroUc}
                                label={
                                    <LabelSelectUcIconeGestor
                                        text={descricaoFiltroUc}
                                        isMulti={true}
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={listaFiltroUc}
                                        setExibirModal={(ucFiltro) =>
                                            setState({
                                                ...state,
                                                exibirModalGestorConcessionaria: true,
                                                itemSelecionado: ucFiltro,
                                            })
                                        }
                                    />
                                }
                                cols="12 12 12 12"
                                placeholder={`Selecione as ${descricaoFiltroUc}`}
                                isMulti={true}
                                value={props.filtro.unidades_consumidoras}
                                onChange={(ucsSelecionadas) => {
                                    if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(props.filtro.ano) && !ucsSelecionadas.length) {
                                        return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        unidades_consumidoras: [...ucsSelecionadas],
                                    });
                                    props.getLista();
                                    resetarListaTabela();
                                }}
                            />
                        ) : null}
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Table
                        ref={tableRef}
                        responsive
                        id="minha-tabela"
                        handleScroll={(containerRef, down) => {
                            const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

                            const pertoDoFim = scrollTop + clientHeight >= scrollHeight - 200;
                            const pertoDoTopo = scrollTop <= 200;

                            setState((prev) => {
                                // garante que prev não seja null/undefined
                                const s = prev || {
                                    aguardando: false,
                                    qtdLinhasRenderizadas: QUANTIDADE_PADRAO_LINHAS,
                                };

                                let novaQtd = s.qtdLinhasRenderizadas;

                                // considera o maior valor para quantidade inicial
                                const quantidadeInicial = Math.max(faturas.length, s.qtdLinhasRenderizadas);

                                if (down && pertoDoFim) {
                                    novaQtd = Math.min(s.qtdLinhasRenderizadas + 15, quantidadeInicial);
                                }

                                // if (!down && pertoDoTopo) {
                                //     novaQtd = Math.max(s.qtdLinhasRenderizadas - 7, 5);
                                // }

                                if (novaQtd === s.qtdLinhasRenderizadas) return s; // sem alteração

                                // evita usar a variável `state` do fechamento — usa updater funcional
                                setTimeout(() => setState((cur) => ({ ...(cur || {}), aguardando: false })), 4000);

                                return { ...(s || {}), qtdLinhasRenderizadas: novaQtd, aguardando: true };
                            });
                        }}
                    >
                        <THead>
                            <NewTr backgroundColorTr="#F9F9F9" backgroundColorTd="#F9F9F9">
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={65} alignCenter title="Status da Importação de Produção de Energia Elétrica Solar">
                                    Status Imp. Prod. Solar
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} alignCenter minWidth={200}>
                                    Cliente/UC
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={75} alignCenter>
                                    Competência/Período
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={110} alignCenter>
                                    Índice Mensal de Aproveitamento da Usina
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={34} alignCenter>
                                    Tarifa
                                </Th>

                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={75} alignCenter>
                                    Constante de Medidor
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} alignCenter>
                                    Valor Fatura (R$)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} alignCenter>
                                    <div>Economias (kWh/R$)</div>
                                    <div>(Creditado)</div>
                                </Th>

                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={75} alignCenter title="Saldo de Produção Solar da Fatura de Energia Elétrica">
                                    Produção Mês e Excedente (kWh)
                                </Th>

                                <Th sticky style={{ fontSize: "0.8rem" }} alignCenter>
                                    Consumo (kWh)
                                </Th>

                                <Th sticky style={{ fontSize: "0.8rem" }} maxWidth={100} alignCenter>
                                    Sobra Mês para Distribuir Compensações (kWh)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} maxWidth={85} alignCenter>
                                    Energia Compensada Efetiva (kWh)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} maxWidth={85} alignCenter>
                                    Energia Compensada Efetiva em (%)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={105} alignCenter>
                                    Rateio Atual Cadastrado na Distribuidora (%)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={85} alignCenter>
                                    Sugestão de Rateio (%)
                                </Th>
                                <Th sticky style={{ fontSize: "0.8rem" }} minWidth={65} alignCenter>
                                    Distribuição Proposta
                                </Th>
                            </NewTr>
                        </THead>
                        {!props.aguardando ? (
                            <TBody>
                                {/* {tabelaUCs} */}
                                {faturas}
                                <Tr>
                                    <Td fontSize="0.8rem" fontWeight="bold">
                                        Total
                                    </Td>
                                    <Td fontSize="0.8rem" fontWeight="bold">
                                        <div className="d-flex">
                                            <div className="pr-5">Qtd. UC:{quantidadeUnidadesFiltradas}</div>
                                            <div>Saldo: {adicionarPontosMilhar(totalSaldo || 0)}</div>
                                        </div>
                                    </Td>
                                    <Td fontSize="0.8rem" colSpan={4} fontWeight="bold"></Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter>
                                        {adicionarPontosMilhar(totalValorImportado || 0)}
                                    </Td>
                                    <Td fontSize="0.8rem" fontWeight="bold"></Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter>
                                        <TableInCell
                                            height={ALTURA_LINHA}
                                            lista={[
                                                {
                                                    cabecalho: (
                                                        <div>
                                                            <div style={{ height: 12, marginTop: 12 }}>Produção</div>
                                                            <div style={{ height: 12 }}>(kWh)</div>
                                                        </div>
                                                    ),
                                                    valor: adicionarPontosMilhar(totalProducaoSolar || 0),
                                                },
                                                {
                                                    cabecalho: (
                                                        <div>
                                                            <div style={{ height: 12, marginTop: 12 }}>Injetado/</div>
                                                            <div style={{ height: 12 }}>Excedente</div>
                                                            <div style={{ height: 12 }}>(kWh)</div>
                                                        </div>
                                                    ),
                                                    valor: adicionarPontosMilhar(totalEnergiaExcedente || 0),
                                                },
                                            ]}
                                        />
                                    </Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter>
                                        {adicionarPontosMilhar(totalenergia || 0)}
                                    </Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter>
                                        {adicionarPontosMilhar(totalSobraDistribuirCompensacoes || 0)}
                                    </Td>
                                    <Td fontSize="0.8rem" fontWeight="bold"></Td>
                                    <Td fontSize="0.8rem" fontWeight="bold"></Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter></Td>
                                    <Td fontSize="0.8rem" fontWeight="bold" alignCenter></Td>
                                    <Td fontSize="0.8rem"></Td>
                                    <Td fontSize="0.8rem"></Td>
                                    <Td fontSize="0.8rem"></Td>
                                </Tr>
                            </TBody>
                        ) : null}
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function filtrarFaturasTabela() {
        if (props.aguardando) return [];
        return props.lista.filter((item, i) => {
            const filtroGeracaoSolar = props.filtro.exibir_remotas ? item.unidade_geradora || item.unidade_remota : item.unidade_geradora;
            const vermelhos = item.erros_importacao.length && !item.importacao_validada;
            const mesmoGrupoFaturamento = !props.filtro.id_grupo_faturamento || item.id_grupo_faturamento == props.filtro.id_grupo_faturamento;
            const filtroConcessionaria = !props.filtro.id_concessionaria || props.filtro.id_concessionaria == item.id_concessionaria;

            const filtroStatusImportacao = ["TODAS", "IMPORTADAS"].includes(props.filtro.status_importacao);
            return props.usuarioLogado && !vermelhos && mesmoGrupoFaturamento && filtroGeracaoSolar && filtroConcessionaria && filtroStatusImportacao;
        });
    }
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.gestaoCreditoSolar.modoTela,
        aguardando: state.gestaoCreditoSolar.aguardando,
        filtro: state.gestaoCreditoSolar.filtro,
        lista: state.gestaoCreditoSolar.lista,
        listaGraficoGeracaoSaldo: state.gestaoCreditoSolar.listaGraficoGeracaoSaldo,
        listaCliente: state.gestaoCreditoSolar.listaCliente,
        listaConcessionaria: state.gestaoCreditoSolar.listaConcessionaria,
        listaUnidadeConsumidora: state.gestaoCreditoSolar.listaUnidadeConsumidora,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
        listaMeses: state.gestaoCreditoSolar.listaMeses,
        listaStatusImportacao: state.gestaoCreditoSolar.listaStatusImportacao,
        pdf: state.displayPDF.pdf,
        id_pdf: state.displayPDF.id_pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            getLista,
            setAguardando,
            getListaGrupoFaturamento,
            resetarFiltro,
            setFiltro,
            getListaGraficoGeracaoSaldo,
            gerarRelatorio,
            setArquivoPDF,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GestaoCreditoSolar);
